import { closeModal, openModal } from '@components/modals';
import { execOnLoad } from '@general/helpers';
import './mobile-menu.scss';
import breakpoints from 'breakpoints';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initMobileMenu = (context) => {
  const snippetContainer = context.classList.contains('.mobile-menu__container')
    ? context
    : context.closest('.mobile-menu__container');
  if (!snippetContainer) return;
  const header = document.querySelector('.header__background');
  const menuOpenButton = snippetContainer.querySelector(
    '.mobile-menu__open-icon',
  );
  const menuCloseButtons = snippetContainer.querySelectorAll(
    '.mobile-menu__close-icon',
  );
  const modal = snippetContainer.querySelector('.modal');
  const enableTransparency = header.hasAttribute('data-transparent');
  if (!menuOpenButton || !menuCloseButtons || !modal) return;

  menuOpenButton.addEventListener('click', () => {
    const announcementHeight = parseInt(
      getComputedStyle(document.documentElement).getPropertyValue(
        '--announcement-bar-height',
      ),
    );
    if (window.scrollY < announcementHeight)
      window.scrollTo({ top: announcementHeight, behavior: 'smooth' });

    snippetContainer.classList.add('open');
    openModal(modal);
    if (enableTransparency) header.dataset.transparent = 'false';
  });

  menuCloseButtons.forEach((btn) => {
    btn.addEventListener('click', () => {
      snippetContainer.classList.remove('open');
      if (enableTransparency) header.dataset.transparent = 'true';
      snippetContainer
        .querySelectorAll('.mobile-menu__second-level.open')
        .forEach((secondLevel) => secondLevel.classList.remove('open'));
    });
  });

  const modalBackdrop = modal.querySelector('.modal__backdrop');
  if (modalBackdrop) {
    modalBackdrop.addEventListener('click', () => {
      snippetContainer.classList.remove('open');
      if (enableTransparency) header.dataset.transparent = 'true';
      snippetContainer
        .querySelectorAll('.mobile-menu__second-level.open')
        .forEach((secondLevel) => secondLevel.classList.remove('open'));
    });
  }

  const lgUp = window.matchMedia(`(min-width: ${breakpoints.lg})`);
  const handleNavigation = () => {
    if (lgUp.matches && snippetContainer.classList.contains('open')) {
      snippetContainer.classList.remove('open');
      closeModal(modal);
      if (enableTransparency) header.dataset.transparent = 'true';
      snippetContainer
        .querySelectorAll('.mobile-menu__second-level.open')
        .forEach((secondLevel) => secondLevel.classList.remove('open'));
    }
  };
  lgUp.addEventListener('change', handleNavigation);
  snippetContainer
    .querySelectorAll('.mobile-menu__first-level--openable')
    .forEach((firstLevel) => {
      const secondLevel = firstLevel.querySelector(
        '.mobile-menu__second-level',
      );
      const opener = firstLevel.querySelector('.mobile-menu__first-level-link');
      if (!secondLevel || !opener) return;
      opener.addEventListener('click', () => secondLevel.classList.add('open'));
    });

  snippetContainer
    .querySelectorAll('.mobile-menu__second-level')
    .forEach((secondLevel) => {
      const close = secondLevel.querySelector('.mobile-menu__back');
      if (!close) return;
      close.addEventListener('click', () =>
        secondLevel.classList.remove('open'),
      );
    });
};

execOnLoad(window.dAgency.initMobileMenu, '.mobile-menu__container');
